import { RouterModule, Routes } from '@angular/router';

import { RemoteDiagnosticsGuardService } from '../shared/services/remote-diagnostics-guard.service';
import { PartnerAccessGuardService } from '../shared/services/partner-access-guard.service';
import { TestAutomationInstallationAccessGuardService } from '../shared/services/test-automation-installation-access-guard.service';
import { RemoteDiagnosticsBackupGuardService } from '../shared/services/remote-diagnostics-backup-guard.service';
import { InstallationDetailsViewGuardService } from '../shared/services/installation-details-view-guard.service';
import { InstallationDetailsGuard } from '../shared/services/installation-details.guard';
import { SrcCommissioningGuard } from '../shared/guards/src-commissioning.guard';
import { PermanentInspectionGuard } from '../shared/guards/permanent-inspection.guard';
import { CascadeRemoteDiagnosticsGuard } from '../shared/services/cascade-remote-diagnostics.guard';

import {
  DiagnosticsUrlTypeEnum,
  PartnerAccessOverlayTypeEnum,
  RemoteServiceUrlTypeEnum,
  SingleRoomControlUrlTypeEnum,
} from './installation/installation-overlay.model';
import { InstallationComponent } from './installation/installation.component';
import { MapComponent } from './map/map.component';
import { InstallationLimitedComponent } from './installation-limited/installation-limited.component';
import { KanbanInstallationListComponent } from '../+kanban-board/kanban-installation-list/kanban-installation-list.component';
import { DashboardInstallationUrls } from './installations-routing.helper';
import { kanbanBoardGuard } from './kanban-board.guard';
import { InstallationsComponent } from './installations/installations.component';
import { oldInstallationListGuard } from './old-installation-list.guard';
import { newInstallationListGuard } from './new-installation-list.guard';
import { authGuard } from '../shared/services/auth-guard';

export const installationsRoutes: Routes = [
  {
    path: DashboardInstallationUrls.List,
    children: [
      // Old list
      {
        path: '',
        pathMatch: 'full',
        canMatch: [authGuard, oldInstallationListGuard],
        component: InstallationsComponent,
      },
      // New list
      {
        path: '',
        pathMatch: 'full',
        canMatch: [authGuard, newInstallationListGuard],
        loadComponent: () =>
          import('./installation-list/installation-list.component').then(
            (m) => m.InstallationListComponent
          ),
      },
      {
        path: DashboardInstallationUrls.Board,
        component: KanbanInstallationListComponent,
        canActivate: [authGuard, kanbanBoardGuard],
      },
      {
        path: DashboardInstallationUrls.Map,
        component: MapComponent,
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'installations/:id',
    component: InstallationComponent,
    canMatch: [InstallationDetailsViewGuardService],
    canActivate: [InstallationDetailsGuard, TestAutomationInstallationAccessGuardService],
    children: [
      {
        path: DiagnosticsUrlTypeEnum.Backups,
        component: InstallationComponent,
        canActivate: [
          RemoteDiagnosticsGuardService,
          RemoteDiagnosticsBackupGuardService,
          CascadeRemoteDiagnosticsGuard,
        ],
      },
      {
        path: DiagnosticsUrlTypeEnum.ExtendedParameter,
        component: InstallationComponent,
        canActivate: [RemoteDiagnosticsGuardService],
      },
      {
        path: DiagnosticsUrlTypeEnum.GuidedTroubleshooting,
        component: InstallationComponent,
        canActivate: [RemoteDiagnosticsGuardService],
      },
      {
        path: DiagnosticsUrlTypeEnum.HydraulicSchematic,
        component: InstallationComponent,
        canActivate: [RemoteDiagnosticsGuardService, CascadeRemoteDiagnosticsGuard],
      },
      {
        path: DiagnosticsUrlTypeEnum.Snapshots,
        component: InstallationComponent,
        canActivate: [RemoteDiagnosticsGuardService, CascadeRemoteDiagnosticsGuard],
      },
      {
        path: SingleRoomControlUrlTypeEnum.SingleRoomControl,
        component: InstallationComponent,
        canActivate: [SrcCommissioningGuard],
      },
      {
        path: SingleRoomControlUrlTypeEnum.Commissioning,
        component: InstallationComponent,
        canActivate: [SrcCommissioningGuard],
      },
      {
        path: RemoteServiceUrlTypeEnum.Anomalies,
        component: InstallationComponent,
        canActivate: [PermanentInspectionGuard],
      },
      {
        path: RemoteServiceUrlTypeEnum.Diagnosis,
        component: InstallationComponent,
        canActivate: [PermanentInspectionGuard],
      },
      {
        path: RemoteServiceUrlTypeEnum.Features,
        component: InstallationComponent,
        canActivate: [PermanentInspectionGuard],
      },
      {
        path: RemoteServiceUrlTypeEnum.Report,
        component: InstallationComponent,
        canActivate: [PermanentInspectionGuard],
      },
      {
        path: PartnerAccessOverlayTypeEnum.Settings,
        component: InstallationComponent,
        canActivate: [PartnerAccessGuardService],
      },
    ],
  },
  {
    path: 'installations/:id',
    component: InstallationLimitedComponent,
  },
];

export const InstallationsRouting = RouterModule.forChild(installationsRoutes);
